export default __webpack_public_path__ + "static/media/SWT0900.34I-22079_-15037_0.ef9e0cf8.jpg";